import 'reflect-metadata';
import './infrastructure/di/setup';
import '@descomplica/design-system-react/core/main.css';
import './index.css';

import { translator } from '@descomplica/microfrontend-react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import Microfrontend from '@/presentation/Microfrontend';

import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement) {
  const createdRoot = createRoot(rootElement);
  createdRoot.render(<Microfrontend />);
  reportWebVitals();
}

export default translator.exposeMicrofrontend(Microfrontend);
